/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// material
import { styled } from '@mui/material/styles';
import { Box, Typography, Select, MenuItem, Container } from '@mui/material';
// components
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LoginForm from '../../components/authentication/Logo/LoginForm';
import SelectSchool from '../../components/authentication/Logo/SelectSchool';
import Phasepage from '../../components/authentication/Logo/Phasepage';
import useLocales from '../../hooks/useLocales';

import { getMerchantId } from '../../redux/slice/user';

import useAuth from '../../hooks/useAuth';

import Group from '../../assets/images/loagin/Group.png';
import poleungkuk from '../../assets/images/loagin/poleungkuk.png';
import ekinder from '../../assets/images/loagin/ekinder.png';

import { setSchool } from '../../redux/slice/global';
import { resetInitialState } from '../../redux/slice/merchant';

const BackDiv = styled('div')({
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: 'Noto Sans TC',
});

const FlexDiv = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const GtBox = styled(Box)({
  width: '14.71px',
  height: '14.71px',
  fontSize: '0.5rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  fontWeight: 600
});

const MySelect = styled(Select)({
  width: '123px',
  height: '28px',
  borderRadius: '2px',
  color: 'gray',
  background: 'white',
});

export default function Login() {
  const { t: tLogin } = useTranslation('login');

  const dispatch = useDispatch();

  const { setMerchantId } = useAuth();

  const { currentLang, onChangeLang } = useLocales();

  const [values, setValues] = useState({
    explor: currentLang.value,
  });

  // 登入成功切換頁面
  const [switchover, setSwitchover] = useState(0);

  const { state } = useLocation();

  useEffect(() => {
    if (state) {
      const { page } = state;

      setSwitchover(page);
    }
  }, [state]);

  // 選擇語言select
  const handleChange = (prop) => (event) => {
    onChangeLang(event.target.value);
    localStorage.setItem('lang', event.target.value);
    setValues({ ...values, [prop]: event.target.value });
  };

  // init login clear merchant_id
  useEffect(() => {
    if (switchover === 0) {
      dispatch(getMerchantId(''));
      setMerchantId('');
      dispatch({ type: 'USER/LOGOUT' });
      dispatch(setSchool({}));
      dispatch(resetInitialState());
      localStorage.setItem('merchant_id', '');
    }
  }, [switchover]);

  return (
    <Box>
      <BackDiv
        style={{
          backgroundImage: `url(${Group})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Box
          sx={{
            background: '#fff',
            borderRadius: '10px',
            padding: switchover ? '47px 0px 0px 0px' : '47px 73px',
            boxSizing: 'border-box',
          }}
        >
          <FlexDiv>
            <img
              src={
                process.env.REACT_APP_HOST === 'plkkgs' ? poleungkuk : ekinder
              }
              alt=""
            />
          </FlexDiv>
          <FlexDiv>
            <Typography
              variant="body1"
              gutterBottom
              sx={{
                color: '#2C3181',
                fontSize: '17px',
                mb: 0,
                fontFamily: 'Noto Sans TC',
              }}
            >
              {tLogin('title')}
            </Typography>
          </FlexDiv>
          {switchover === 0 && (
            <Box>
              <FlexDiv sx={{ mt: '23px', mb: 3 }}>
                <LoginForm cut={() => setSwitchover(1)} />
              </FlexDiv>
              <FlexDiv>
                <Box
                  sx={{ width: '24px', height: '24px', position: 'relative' }}
                >
                  <GtBox
                    sx={{
                      border: '1px solid black',
                      position: 'absolute',
                      top: '1.5px',
                      left: '1.5px',
                    }}
                  >
                    文
                  </GtBox>
                  <Box
                    sx={{
                      width: '5.42px',
                      height: '5.42px',
                      border: '1px solid black',
                      position: 'absolute',
                      bottom: '3.5px',
                      left: '6.5px'
                    }}
                  />
                  <GtBox
                    sx={{
                      border: '1px solid black',
                      background: 'black',
                      color: '#fff',
                      position: 'absolute',
                      bottom: '-2.5px',
                      right: '-0.5px'
                    }}
                  >
                    A
                  </GtBox>
                </Box>
                <Box sx={{ ml: '10px' }}>
                  <MySelect
                    sx={{
                      '& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input':
                      {
                        pt: '8px',
                        pb: '5px',
                        pl: '7px',
                        fontSize: '0.75rem',
                        color: '#000000',
                      },
                      '& .css-vewk60-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root':
                      {
                        pt: '6px',
                      },
                    }}
                    value={values.explor}
                    onChange={handleChange('explor')}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                    <MenuItem
                      value="zh"
                      sx={{ fontSize: '0.75rem', color: '#000000' }}
                    >
                      {tLogin('Traditional')}
                    </MenuItem>
                    <MenuItem
                      value="cn"
                      sx={{ fontSize: '0.75rem', color: '#000000' }}
                    >
                      {tLogin('Simplified')}
                    </MenuItem>
                    <MenuItem
                      value="english"
                      sx={{ fontSize: '0.75rem', color: '#000000' }}
                    >
                      English
                    </MenuItem>
                  </MySelect>
                </Box>
              </FlexDiv>
              <Container sx={{ color: '#7b7b7b', mt: 1, ml: 1.2, textAlign: 'center' }}>
                {process.env.REACT_APP_VERSION}
              </Container>
            </Box>
          )}
          {switchover === 1 && <SelectSchool cut={() => setSwitchover(2)} />}
          {switchover === 2 && (
            <Phasepage
              cutLogin={() => setSwitchover(0)}
              cut={() => setSwitchover(1)}
            />
          )}
        </Box>
      </BackDiv>
    </Box>
  );
}
